import { render, staticRenderFns } from "./reg-middle-header.vue?vue&type=template&id=f5d93e9c&scoped=true&"
import script from "./reg-middle-header.vue?vue&type=script&lang=js&"
export * from "./reg-middle-header.vue?vue&type=script&lang=js&"
import style0 from "./reg-middle-header.vue?vue&type=style&index=0&id=f5d93e9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d93e9c",
  null
  
)

export default component.exports